import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from '../../select';
import { getTranslation } from '../../../utils/translations';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { setNavItem } from 'common/store/modules/competition-nav/init';
import {
    useGetCompSeasonQuery,
    useGetRoundsQuery
} from 'common/store/modules/api/afl-api';
import { SvgIcon } from '../../SvgIcon';

export const ResponsiveRoundNavItem = ({ removeFinals }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);

    const { data: roundsFromStore, isError: roundsLoadError } =
        useGetRoundsQuery(
            {
                compseasonId: nav.season.id,
                params: { pageSize: 50 }
            },
            {
                skip: !nav.season.id
            }
        );

    const { data: compSeason } = useGetCompSeasonQuery(
        {
            id: nav.season.id
        },
        {
            skip: !nav.season.id
        }
    );

    const roundsList = removeFinals
        ? roundsFromStore?.filter(PULSE.app.common.match.isNonFinalRound)
        : roundsFromStore;

    return !roundsLoadError &&
        !(Array.isArray(roundsList) && roundsList.length === 0) ? (
        <div className="competition-nav__season-select">
            <SvgIcon
                icon="calendar"
                className="competition-nav__season-select-icon"
            />

            <SvgIcon
                className="competition-nav__season-select-chevron"
                icon="chevron-down"
            />

            <Select
                items={roundsList}
                itemToString={(round) => round?.name}
                initialSelectedItem={
                    roundsList && nav.round.id
                        ? roundsList.find((s) => s.id === Number(nav.round.id))
                        : ''
                }
                activeItem={
                    roundsList && nav.round.id
                        ? roundsList.find((s) => s.id === Number(nav.round.id))
                        : ''
                }
                isReadyToRender={() =>
                    roundsList?.length && Number(nav.round.id)
                }
                label={getTranslation('label.stats.round')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        setNavItem({
                            navItem: 'round',
                            value: selectedItem
                        })
                    );
                }}
                currentRoundIndex={compSeason?.currentRoundNumber - 1 || false}
                hideLabel
            />
        </div>
    ) : null;
};

ResponsiveRoundNavItem.propTypes = {
    removeFinals: PropTypes.bool
};
